export default "__VITE_ASSET__a4e7e950__"